import { UI_API_METHOD_TYPES, type UiPromptPiaRequest, type UiPromptPiaResponse } from '@sdk/api/modules/ui/types.ui'
import { usePostRobot } from '@lib/sdk/utils/postrobot'

/**
 * Sends a query to the Pitcher Intelligent Assistant (PIA) and handles the streamed response.
 *
 * @example
 * // Subscribe to PIA's streamed responses
 * const cleanup = await useUi().on(
 *   UI_MESSAGE_TYPES.UI_PROMPT_PIA_RESPONSE_STREAMED,
 *   async ({ chunk, partial_response, id }) => {
 *     console.log(`PIA response chunk for stream ${id}: ${chunk}`);
 *     console.log(`PIA response so far for stream ${id}: ${partial_response}`);
 *   }
 * );
 * // Prompt PIA with a question and ensure cleanup is called afterwards
 * useUi().promptPia({ prompt: "What's my most presented file?", id: 'my-prompt-id-to-discern-with-stream-event' })
 *   .finally(cleanup);
 */
export async function promptPia(payload: UiPromptPiaRequest): Promise<UiPromptPiaResponse> {
  const pr = await usePostRobot()
  const r = await pr.send(window.parent, UI_API_METHOD_TYPES.UI_PROMPT_PIA, payload)
  return r.data as UiPromptPiaResponse
}
